import { colorTextSecondary } from 'component/color';
import { FormField, SaveableTextField } from 'component/form';
import { TextArea, TextField, UtilityText } from 'component/text';
import type { SpacesConfig, SpaceTemplate } from 'feature/editorial-dash/spaces';
import { getFontSize } from 'platform-specific/font';
import { StyleSheet, View } from 'react-native';
import { useDatastore, useGlobalProperty } from 'util/datastore';
import type { Feature } from 'util/stdtypes';
import { TLabel, t } from 'util/stdtypes';

function ConfigWidget({ spaceProps, setSpaceProps }) {
    return (
        <View>
            <FormField descriptionLabel={t('Separate perspectives with a line break.')} label={t('Perspectives')} required>
                <TextArea
                    onChange={(text) => setSpaceProps({ ...spaceProps, perspectives: text })}
                    placeholderLabel={t('Write 3-5 perspectives...')}
                    value={spaceProps.perspectives}
                />
            </FormField>
        </View>
    );
}

function EditWidget() {
    const datastore = useDatastore();
    const perspectives = useGlobalProperty('perspectives');
    return (
        <View>
            <SaveableTextField
                descriptionLabel={t('Separate perspectives with a line break.')}
                label={t('Perspectives')}
                multiline
                onSave={(text) => datastore.setGlobalProperty('perspectives', text)}
                required
                testID='perspectives-input'
                value={perspectives}
            />
        </View>
    );
}

export const RepresentingPerspectivesTemplate: SpaceTemplate = {
    key: 'representing-perspectives',
    label: t('Representing Perspectives'),
    description: t('Ask users from a specific set of perspectives to respond to your question.'),
    imageUrl: 'images/representing-perspectives.svg',
    structureKey: 'question',
    featuresEnabled: ['representing_perspectives'],
    configWidget: ConfigWidget,
    editWidget: EditWidget,
    isCreateAllowed: ({ spaceProps }) => {
        return spaceProps.perspectives;
    },
};

export const RepresentingPerspectivesTemplateFeature: Feature<SpacesConfig, {}> = {
    key: 'representing-perspectives-template',
    name: 'Representing Perspectives Template',
    dev: true,
    providesConfig: {
        templates: [RepresentingPerspectivesTemplate],
    },
};
